import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { of, throwError, delay } from 'rxjs';
import { MockDataService, type MutationRequestBody, HttpMethod } from '../../shared/mock/core/mock-data.service';


// Default error message for mock error responses
export const MOCK_UNKNOWN_ERROR = 'Unknown error';
// Default status text for mock error responses
export const MOCK_BAD_REQUEST_STATUS_TEXT = 'Bad Request';

/**
 * HTTP interceptor function that routes API requests to mock data service
 */
export const mockResponseDelay = 300;

export const mockInterceptor: HttpInterceptorFn = (request, next) => {
  const mockDataService = inject(MockDataService);

  // Always pass the request body and method as-is to the service
  const mockResponse = mockDataService.handleRequest(
    request.url,
    request.method,
    request.method === 'GET' ? undefined : request.body
  );

  if (mockResponse === null) {
    // No mock configured or invalid types, pass through
    return next(request);
  }

  if (mockResponse && 'success' in mockResponse && !mockResponse.success) {
    const errorResponse = new HttpErrorResponse({
      error: mockResponse.error ?? MOCK_UNKNOWN_ERROR,
      status: 400,
      statusText: MOCK_BAD_REQUEST_STATUS_TEXT,
      url: request.url,
    });
    return throwError(() => errorResponse).pipe(delay(mockResponseDelay));
  }

  return of(new HttpResponse({
    status: 200,
    body: mockResponse.data,
  })).pipe(delay(mockResponseDelay));
};
